import React, { useContext } from 'react'
import { useSelector } from 'react-redux'

import cx from 'classnames'
import { RootState } from 'typesafe-actions'

import { H3 } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

import AccountSyncFromSalesforcePanel from 'components/AccountSyncFromSalesforcePanel'
import { DateRangePicker } from 'components/DateRangePicker'
import { EngagementScoreFlames } from 'components/EngagementScoreFlames'
import { Header, Navigation } from 'components/Header'
import { FiltersContext } from 'context/filtersContext'
import { OpenedSidebar, SidebarOpenContext } from 'context/sidebarOpenContext'
import { useAccountAccountExplain } from 'hooks/useAccountExplain'
import { getIntegration } from 'modules/users/selectors'

import sharedStyles from '../../styles/shared.module.css'
import styles from './styles.module.css'

export const AccountActivityHeader = ({
  title,
  showDetailToggle,
  navigation,
  accountEngagementScore,
  showDateRange = true
}: {
  title: string
  showDetailToggle?: boolean
  content?: React.ReactElement
  navigation?: Navigation
  accountEngagementScore?: number
  showDateRange?: boolean
}) => {
  const { openedRightSidebar, setOpenedRightSidebar } = useContext(SidebarOpenContext)
  const { dateRange, setDateRange } = useContext(FiltersContext)
  const isSalesforceConnected = useSelector<RootState, any>(getIntegration('salesforce'))

  const { data } = useAccountAccountExplain()

  const engagmentScore =
    accountEngagementScore ??
    (data?.normalizedEngagementScore && Math.min(Math.round(data?.normalizedEngagementScore), 5)) ??
    undefined

  const onOpenSidebar = () => {
    setOpenedRightSidebar(
      openedRightSidebar === OpenedSidebar.DETAILS ? OpenedSidebar.NONE : OpenedSidebar.DETAILS
    )
  }

  const filter = (
    <div className={styles.filters}>
      <div className={styles.rightSideHeaderOptions}>
        <div className={styles.marginRight}>
          {isSalesforceConnected && <AccountSyncFromSalesforcePanel />}
        </div>
        {showDateRange && (
          <DateRangePicker onDateRangeChange={setDateRange} dateRange={dateRange} />
        )}
      </div>
      {showDetailToggle && (
        <React.Fragment>
          {
            <div></div> /* pushed content to the right for alignment because we don't have two elements in the grid */
          }
          <button
            onClick={onOpenSidebar}
            className={cx(sharedStyles.tideButton, styles.detailsSidebarToggle, {
              [styles.active]: openedRightSidebar === OpenedSidebar.DETAILS
            })}>
            <Icon className={styles.icon} name="info" width={13} height={13} />
            {openedRightSidebar !== OpenedSidebar.DETAILS ? 'Account details' : ''}
          </button>
        </React.Fragment>
      )}
    </div>
  )

  const header = (
    <div className={styles.headerTitle}>
      <H3 className={styles.title}>{title}</H3>
      {!!engagmentScore && <EngagementScoreFlames score={engagmentScore} />}
    </div>
  )

  return (
    <Header
      title={title}
      header={header}
      content={filter}
      contentClassName={showDateRange ? styles.datePickerSavedViews : undefined}
      navigation={navigation}
    />
  )
}
